export default "__VITE_ASSET__Cc2q2s5n__"